export const relationshipName = 'relationship'
